export default "__VITE_ASSET__cc13d044__"